import UserProfile from '~/components/GlobalHeader/Shared/components/ProfileDetail';

import type { CompanyInfo, UserInfo } from '~/components/GlobalHeader/Shared/type';
import { isRIScorecardAccessible } from '../../../utils';
import { MixpanelEventNameType, MixpanelTrackType } from '../../Help/type';
import Label from '@mindtickle/label';
import { TEXT_COLORS, TEXT_TYPES } from '@mindtickle/styles/lib/classNames';
import { URLS } from '../../../config/constants';
import messages from './messages';

type ViewProfileProps = {
  user: UserInfo;
  company: CompanyInfo;
  eventName: MixpanelEventNameType;
  track: MixpanelTrackType<MixpanelEventNameType>;
  onHideDropdownContent: Function;
};

const ViewProfile = ({
  user,
  company,
  eventName,
  track,
  onHideDropdownContent,
}: ViewProfileProps) => {
  const showViewProfileAndAnalytics = isRIScorecardAccessible(company.companySettings);

  // This is as it is migrated from the learner header in UI container
  const handleProfileView = () => {
    track(eventName);
    window.location.hash = URLS.PROFILE_URL(user.id);
    onHideDropdownContent();
  };

  return (
    <UserProfile
      user={user}
      customViewProfileNode={
        <Label
          onClick={handleProfileView}
          type={TEXT_TYPES.LABEL_MEDIUM_DEFAULT}
          color={TEXT_COLORS.TERTIARY}
          message={
            showViewProfileAndAnalytics ? messages.MY_PROFILE_AND_ANALYTICS : messages.MY_PROFILE
          }
          data-testid={'view-profile-btn'}
          className="view-profile"
        />
      }
    />
  );
};

export default ViewProfile;
